module.exports = __webpack_public_path__ + "static/media/2_Profil_sigtuna.e3f738fb.jpeg";